import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { NavController } from '@ionic/angular/standalone';
import { environment } from 'src/environments/environment';

export const isWebGuard: CanActivateFn = () => {
    const navController: NavController = inject(NavController);

    const isWeb = environment.isWeb;
    if (!isWeb) navController.navigateBack('/dashboard');
    return isWeb;
};
